import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { Auth } from '@aws-amplify/auth';

import { UserService } from '@authentication/services/user.service';

@Injectable({ providedIn: 'root' })
export class AuthenticatedGuard {
  constructor(private router: Router, private userService: UserService) {}

  async canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return Auth.currentSession()
      .then((session) => {
        if (session.isValid()) {
          return true;
        } else {
          this.userService.logout();
          return this.router.createUrlTree(['/auth/login'], {
            queryParams: { redirect: state.url },
          });
        }
      })
      .catch(() => {
        this.userService.logout();
        return this.router.createUrlTree(['auth/login'], {
          queryParams: { redirect: state.url },
        });
      });
  }
}
